import { apiSlice } from "../app/api/apiSlice";

export const sqlApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAllFavouritesWorkbook: builder.query({
            query: () => ({
                url: `/users/allfavouritesWorkbook`,
                method: "GET",
            }),
            providesTags: [{ type: "FolderFileData", id: "root" }],
        }),
        // Add other endpoints here
    }),
});

export const { useGetAllFavouritesWorkbookQuery } = sqlApiSlice;
